import useSWR from 'swr'

import { useApis } from '../../contexts/api-context'
import { type DiagnosisPreviewType } from '../../types/DiagnosisStateType'

export const fetchDiagnosisPreview = async (api: any, diagnosis: DiagnosisPreviewType) => {
  const res = await api.getDiagnosisPreview(diagnosis)
  return res.data
}

const useDiagnosisPreview = (diagnosis: DiagnosisPreviewType) => {
  const { api } = useApis()
  const hasValidService =
    (diagnosis.services?.length ?? 0) > 0 && diagnosis.services?.every((value) => value !== undefined && value !== null)

  const { data, error } = useSWR(hasValidService ? ['diagnosisPreview'] : null, () => {
    return fetchDiagnosisPreview(api, diagnosis)
  })

  return {
    data,
    isLoading: !error && !data,
  }
}

export default useDiagnosisPreview
